export default "__VITE_ASSET__g2kmJ2XO__"